<template>
  <div class="">
    <Header
      title="My Admin"
      description="Manage administrative control over your platform. Manage user permission, access settings, and oversee various administrative features to keep your platform running smoothly."
    />
    <div class="flex bg-white fixed-top">
      <div class="p-6 w-full pb-8 menucontrol-scroll">
        <Custom-pages
          :customPages="filteredCustomPages"
          v-if="
            ['Admin', 'Developer'].includes(login.role) ||
            multiLineArray(userModules, customPages)
          "
        />

        <UserManagement
          v-if="
            ['Admin', 'Developer'].includes(login.role) ||
            modules.filter((x) => x === 'User Management').length
          "
        />

        <project-management
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Project Management' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role) &&
                  login.reseller == selectedProject.reseller) ||
                (x === 'Project Management' &&
                  login.reseller == selectedProject.reseller)
            ).length
          "
        />
        <AdminBlogs
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Blog' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Blog'
            ).length
          "
        />

        <Portfolio
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Portfolio' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Portfolio'
            ).length
          "
        />

        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Ecommerce' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Ecommerce'
            ).length
          "
        >
          <Ecommerce />
        </div>
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Marketplace' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Marketplace'
            ).length
          "
        >
          <Marketplace />
        </div>
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'OTT' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'OTT'
            ).length
          "
        >
          <OTT />
        </div>
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Booking Engine' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Booking Engine'
            ).length
          "
        >
          <BookingEngine />
        </div>
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Metaverse' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Metaverse'
            ).length
          "
        >
          <Metaverse />
        </div>
        <!-- v-if="
            extensions.filter(
              (x) =>
                x.extensionId.name === 'Whatsapp Bot' && x.status === 'Active'
            ).length
          " -->
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Whatsapp Bot' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'Whatsapp Bot'
            ).length
          "
        >
          <WhatsAppBot />
        </div>
        <!-- v-if="
            extensions.filter(
              (x) =>
                x.extensionId.name === 'E-learning' && x.status === 'Active'
            ).length
          " -->
        <!-- 
          <div
            v-if="
              extensions.filter(
                (x) =>
                  x.extensionId.name === 'E-learning' && x.status === 'Active'
              ).length
            "
          >
            <Elearning />
          </div> -->
        <div
          v-if="
            modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'E-learning' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(login.role)) ||
                x === 'E-learning'
            ).length
          "
        >
          <Elearning />
        </div>
        <div>
          <AdminSocial
            v-if="
              modules.filter(
                (x) =>
                  (x.extensionId &&
                    x.extensionId.name === 'Social' &&
                    x.status === 'Active' &&
                    ['Admin', 'Developer'].includes(login.role)) ||
                  x === 'Social'
              ).length
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Plans from "@/views/adminPanel/pages/ecommerce/components/Plans";
import UserManagement from "./components/UserManagement";
import Ecommerce from "./components/Ecommerce";
import Elearning from "./components/Elearning";
import Marketplace from "./components/Marketplace";
import WhatsAppBot from "./components/WhatsAppBot";
import Metaverse from "./components/Metaverse";
import BookingEngine from "./components/BookingEngine";
import AdminSocial from "./components/AdminSocial";
import AdminBlogs from "./components/AdminBlogs";
import Portfolio from "./components/Portfolio";
import OTT from "./components/OTT";
import CustomPages from "./components/customPages.vue";
import projectManagement from "./components/projectManagement.vue";
import { mapState } from "vuex";
import Header from "@/views/adminPanel/layouts/components/Header";

export default {
  components: {
    UserManagement,
    Ecommerce,
    Elearning,
    Plans,
    Marketplace,
    WhatsAppBot,
    Metaverse,
    BookingEngine,
    AdminSocial,
    AdminBlogs,
    projectManagement,
    Portfolio,
    OTT,
    Header,
    CustomPages,
  },
  data() {
    return {
      extensions: [],
      modules: [],
      filteredCustomPages: [],
    };
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["userModules", "login", "allModules"]),
    ...mapState("AdminPages", ["customPages"]),
  },
  methods: {
    async getExtensions() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "Extensions/getExtensionRequest",
        payload
      );
      // this.extensions = data.data;
      if (this.userModules) {
        this.modules = [...data.data, ...this.userModules];
      } else {
        this.modules = [...data.data];
      }
    },

    async getAdminPages() {
      // let tasklist = await this.$store.dispatch("builder/getTasklist", {
      //   projectName: this.selectedProject.projectName,
      // });
      let { data } = await this.$store.dispatch("AdminPages/GET");
      if (this.userModules) {
        this.modules = [...data, ...this.userModules];
      } else {
        this.modules = [...data];
      }
      // this.$emit(
      //   "customPages",
      //   this.customPages.length ? this.customPages : []
      // );
      // this.cards = data.map((x) => {
      //   return {
      //     title: x.page,
      //     image: `${x.icon}`,
      //     route: x.hasOwnProperty("path") ? x.path : "",
      //   };
      // });
      // console.log(data);
    },

    multiLineArray(arr, values) {
      let array = values.map((x) => x.title);
      console.log(array, "MAP");
      const ret = array.some((value) => {
        console.log(value, "VAL");
        return arr.includes(value);
      });
      console.log(ret, "RET");
      return ret;
    },
  },
  async mounted() {
    this.$vs.loading();
    // await this.$store.dispatch("project/getModules");
    await this.getAdminPages();
    await this.getExtensions();
    if (!["Admin", "Developer"].includes(this.login.role)) {
      this.filteredCustomPages = this.customPages.filter((value) => {
        console.log(value, "VAL");
        return this.userModules.includes(value.title);
      });
    } else this.filteredCustomPages = this.customPages;
    this.$vs.loading.close();
  },
};
</script>
